import React, { ReactNode } from 'react';
import HamburgerMenu from '../HamburgerMenu';
import '../../styles/PageHeader.css';

interface PageHeaderProps {
  title: string;
  rightContent?: ReactNode;
  headerActions?: ReactNode[];
  showMenu?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, rightContent, headerActions = [], showMenu = true }) => {
  return (
    <header className="page-header">
      {/* Left side with title */}
      <div className="title-container">
        <h1>{title}</h1>
      </div>
      
      {/* Right side with actions/hamburger */}
      <div className="header-actions">
        {headerActions.map((action, index) => (
          <div key={`header-action-${index}`} className="header-action-item">
            {action}
          </div>
        ))}
        {rightContent || (showMenu && <HamburgerMenu />)}
      </div>
    </header>
  );
};

export default PageHeader;
